import { render } from "./OpenIcon16.vue.js?vue&type=template&id=0ccbf240!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./OpenIcon16.vue?vue&type=template&id=0ccbf240"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__